import { gettext } from '@eventbrite/i18n';
import React from 'react';
import {
    Organizer,
    OrganizersSection,
} from '../../components/OrganizersSection';
import { ThingsToDoSection } from '../../components/ThingsToDoSection';
import { useLocationContext } from '../../context';
import { SUBHEADER } from './constants';

export interface TopOrganizersProps {
    topOrganizers: Organizer[];
}

export const TopOrganizers: React.FunctionComponent<TopOrganizersProps> = (
    props,
) => {
    const { shortPlaceName } = useLocationContext();

    return (
        <ThingsToDoSection>
            <OrganizersSection
                header={gettext('Top organizers in %(shortPlaceName)s', {
                    shortPlaceName,
                }).toString()}
                subHeader={SUBHEADER.toString()}
                organizersList={props.topOrganizers}
            />
        </ThingsToDoSection>
    );
};
